.main-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: var(--white);
    box-sizing: border-box;
}
